import React from 'react';
import { Box, Container, Flex, IconButton, ListItem, Text, UnorderedList } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { ArrowRightIcon } from '@chakra-ui/icons';

export interface Stage {
    title: string;
    steps: {
        id: string;
        description: string;
    }[];
    result: string;
    link: string;
}

interface Props {
    data: Stage;
    navigationDisabled?: boolean;
}

function Process(props: Props) {
    const {
        data,
        navigationDisabled = false,
    } = props;
    const navigate = useNavigate();

    return (
        <Container
            borderWidth={1}
            padding={2}
        >
            <Flex
                borderWidth={1}
                padding={2}
                marginBottom={1}
                justifyContent="space-between"
                alignItems="center"
            >
                <Text fontWeight="bold">{data.title}</Text>
                {!navigationDisabled && (
                    <IconButton
                        onClick={() => navigate(data.link)}
                        aria-label={data.title}
                        icon={<ArrowRightIcon />}
                        variant="outline"
                        size="sm"
                    />
                )}
            </Flex>
            <Box
                borderWidth={1}
                width="100%"
                padding={2}
                marginBottom={1}
            >
                <UnorderedList
                    paddingX={4}
                    paddingY={2}
                >
                    {data.steps.map((d) => (
                        <ListItem
                            key={d.id}
                            p={2}
                        >
                            <Text>{d.description}</Text>
                        </ListItem>
                    ))}
                </UnorderedList>
            </Box>
            <Box borderWidth={1} width="100%" padding={4}>
                <Text fontWeight="bold">{data.result}</Text>
            </Box>
        </Container>
    );
}

export default Process;
